import React, { JSX, useContext, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { ServiceId } from '@/@types/application';
import CurrentEvents from '../components/CurrentEvents';
import Layout from '../components/Layout';
import MaintenanceSchedule from '../components/MaintenanceSchedule';
import Section from '../components/Section';
import StatusPanel from '../components/StatusPanel';
import { PAGE_TITLE_SUFFIX, SERVICES } from '../constants';
import { BreadcrumbType, Store } from '../store';
import NotFound from './NotFound';

type DetailParams = {
  serviceId: ServiceId;
};

const Detail: React.FC = (): JSX.Element => {
  const { serviceId } = useParams<DetailParams>();
  const validServiceId = serviceId && serviceId in SERVICES ? serviceId : undefined;
  const { setGlobalState } = useContext(Store);

  // biome-ignore lint/correctness/useExhaustiveDependencies: マウント時に1度だけ実行
  useEffect(() => {
    let breadcrumbs: BreadcrumbType[] = [
      { text: 'メンテナンス・障害情報', path: '/' },
      { text: validServiceId ? SERVICES[validServiceId] : '', path: `/${validServiceId}/` },
    ];
    document.title = `${breadcrumbs.slice(-1)[0]?.text} メンテナンス・障害情報 ${PAGE_TITLE_SUFFIX}`;

    if (!validServiceId) {
      breadcrumbs = [{ text: 'お探しのページが見つかりませんでした', path: '/' }];
      document.title = `ページが見つかりませんでした ${PAGE_TITLE_SUFFIX}`;
    }

    setGlobalState({ type: 'SET_BREADCRUMBS', payload: breadcrumbs });
    window.scrollTo(0, 0);
  }, []);

  if (!validServiceId) {
    return <NotFound />;
  }

  return (
    <Layout>
      <Section>
        <StatusPanel serviceId={validServiceId} location="detail" />
      </Section>
      <CurrentEvents serviceId={validServiceId} />
      <MaintenanceSchedule serviceId={validServiceId} />
    </Layout>
  );
};

export default Detail;
